var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9391 17.9994L21.803 15.1418C21.9284 15.0164 21.9989 14.8462 21.9989 14.6688C21.9989 14.4915 21.9284 14.3213 21.803 14.1959C21.6776 14.0705 21.5075 14 21.3301 14C21.1528 14 20.9827 14.0705 20.8572 14.1959L18 17.0602L15.1428 14.1959C15.0173 14.0705 14.8472 14 14.6699 14C14.4925 14 14.3224 14.0705 14.197 14.1959C14.0716 14.3213 14.0011 14.4915 14.0011 14.6688C14.0011 14.8462 14.0716 15.0164 14.197 15.1418L17.0609 17.9994L14.197 20.8571C14.1346 20.919 14.085 20.9927 14.0512 21.0738C14.0174 21.155 14 21.2421 14 21.33C14 21.418 14.0174 21.505 14.0512 21.5862C14.085 21.6674 14.1346 21.741 14.197 21.803C14.2589 21.8654 14.3326 21.915 14.4137 21.9488C14.4949 21.9826 14.582 22 14.6699 22C14.7578 22 14.8449 21.9826 14.926 21.9488C15.0072 21.915 15.0808 21.8654 15.1428 21.803L18 18.9387L20.8572 21.803C20.9192 21.8654 20.9928 21.915 21.074 21.9488C21.1551 21.9826 21.2422 22 21.3301 22C21.418 22 21.5051 21.9826 21.5863 21.9488C21.6674 21.915 21.7411 21.8654 21.803 21.803C21.8654 21.741 21.915 21.6674 21.9488 21.5862C21.9826 21.505 22 21.418 22 21.33C22 21.2421 21.9826 21.155 21.9488 21.0738C21.915 20.9927 21.8654 20.919 21.803 20.8571L18.9391 17.9994Z",
    fill: "#858E99"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#E3E5E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.d158c27405ff0829a50f957796150425.svg";
export { ForwardRef as ReactComponent };